<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Nuevo Servicio para {{ categoria.descripcion }}</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <mat-tab-group dynamicHeight="true">
            <form class="form" [formGroup]="formulario" autocomplete="off">
                <mat-tab label="Servicio">
                    <div class="p-24">
                        <mat-form-field class="full-width">
                            <mat-label>Grupo </mat-label>
                            <mat-select formControlName="grupo">
                                <mat-option
                                    *ngFor="let grupo of grupos"
                                    [value]="grupo.id"
                                >
                                    {{ grupo.descripcion }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Nombre </mat-label>

                            <input
                                matInput
                                type="text"
                                name="nombre"
                                formControlName="nombre"
                            />
                            <mat-error *ngIf="nombre.hasError('required')">
                                Debe ingresar el nombre del servicio
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Valor desde </mat-label>

                            <input
                                matInput
                                type="number"
                                name="desde"
                                formControlName="desde"
                            />
                            <span matPrefix>UF&nbsp;</span>

                            <mat-error *ngIf="desde.hasError('required')">
                                Debe ingresar la fecha de pago
                            </mat-error>
                            <mat-error *ngIf="desde.value > hasta.value">
                                El valor hasta no puede ser mayor que el desde
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Valor hasta </mat-label>

                            <input
                                matInput
                                type="number"
                                name="hasta"
                                formControlName="hasta"
                            />
                            <span matPrefix>UF&nbsp;</span>

                            <mat-error *ngIf="hasta.hasError('required')">
                                Debe ingresar la fecha de pago
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Unidad Medida </mat-label>
                            <mat-select formControlName="medida">
                                <mat-option
                                    *ngFor="let unidad of unidadMedida"
                                    [value]="unidad.id"
                                >
                                    {{ unidad.descripcion }}
                                </mat-option>
                            </mat-select>

                            <mat-error *ngIf="hasta.hasError('required')">
                                Debe ingresar la fecha de pago
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Unidad Tiempo </mat-label>
                            <mat-select formControlName="tiempo">
                                <mat-option [value]="-1"></mat-option>
                                <mat-option
                                    *ngFor="let unidad of unidadTiempo"
                                    [value]="unidad.id"
                                >
                                    {{ unidad.descripcion }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </mat-tab>
                <mat-tab
                    *ngIf="categoria.atributos?.length > 0"
                    label="Atributos"
                >
                    <mat-form-field
                        *ngFor="
                            let atributo of categoria.atributos;
                            let i = index
                        "
                        class="full-width"
                    >
                        <mat-label>{{ atributo.descripcion }} </mat-label>
                        <input
                            matInput
                            type="text"
                            name="atributo.descripcion"
                            formControlName="attr_{{ atributo.descripcion }}"
                        />

                        <mat-error
                            *ngIf="
                                formulario.controls[
                                    'attr_' + atributo.descripcion
                                ]?.hasError('required')
                            "
                        >
                            El valor de {{ atributo.descripcion }} es
                            obligatorio
                        </mat-error>
                    </mat-form-field>
                </mat-tab>
            </form>
        </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formulario.value"
            [disabled]="!formulario.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
